
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8086a76a!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TotalCountComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TotalCountComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8086a76a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TotalCountComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/TotalCountComponent.vue
// module id = 241
// module chunks = 2